import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API()+'wynajem';

export default {

    addWynajem(data){
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    aktualizujWynajem(id, data){
        return axios({
            method: 'put',
            url: URL + '/' + id,
            data: JSON.stringify(data),
        })
    },

    getWynajem(){
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getWynajemId(id){
        return axios({
            method: 'get',
            url: URL + '/form/' + id,
        });
    },

    getWynajemData(dataOd, dataDo){
        return axios({
            method: 'get',
            url: URL + '/szukajWithResource/?dataOd=' + dataOd + '&dataDo=' + dataDo,
        });
    },

    usunWynajem(id){
        return axios({
           method: 'delete',
           url: URL + '/' + id
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/WynajemService.js